import { createFileRoute } from '@tanstack/react-router';

import { RoiDashboardPage } from '@/features/roi-demo/components/RoiDashboardPage';

export const Route = createFileRoute('/roi-demo')({
  component: RoiDemoRoute,
});

function RoiDemoRoute() {
  return <RoiDashboardPage />;
}
